import React, { useContext, useEffect } from 'react';
import useOnChange from '../../../../hooks/useChange'
import { ContextBuilder } from '../../../../context/builder/reducers';
import types from './types';
import Select from '../Select';

const Projects = (props) => {
    const { state, dispatch } = useContext(ContextBuilder);
    const onChange = useOnChange(props.index);
    useEffect(() => {
        if (!props.content) {
            const data = state.data;
            data.value[props.index].content = {type: null };
            dispatch({ type: 'data', payload: { data: data } });
        }
    });

    return (
        <div className="about-us">
            <h2>Projects</h2>
            <div className="form-group">
                <label>Тип</label>
                <Select className="form-control" value={props.content.type || ''} name="type" onChange={onChange}>
                    {types.map((item, i) => {
                        return (
                            <Select.Option key={item.id} value={item.id}>
                                {item.label}
                            </Select.Option>
                        );
                    })}
                </Select>
            </div>
        </div>
    );
}

export default Projects;
